import { useState } from "react";
import { faqs } from "../data";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-[0.85fr,1.15fr] gap-10 lg:gap-16">
          <div>
            <SectionHeading
              eyebrow="FAQ"
              title="常见问题"
              desc="关于报名、参赛条件与评选标准，这里集中回答了问得最多的几个问题。如果还有没覆盖到的，欢迎直接联系我们。"
            />
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-foreground-950 hover:bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap transition-colors"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              还有问题，问我们
            </a>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((item, index) => {
              const isOpen = open === index;
              return (
                <div
                  key={item.q}
                  className={`rounded-lg border transition-colors ${
                    isOpen ? "bg-background-100 border-primary-300" : "bg-background-50 border-background-200"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 cursor-pointer"
                    >
                      <span
                        className={`font-heading text-sm md:text-base font-bold ${
                          isOpen ? "text-primary-700" : "text-foreground-950"
                        }`}
                      >
                        {item.q}
                      </span>
                      <span
                        className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                      </span>
                    </button>
                  </h3>
                  <div
                    className={`overflow-hidden transition-[max-height] duration-300 ${
                      isOpen ? "max-h-72" : "max-h-0"
                    }`}
                  >
                    <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}